import { render, staticRenderFns } from "./OnUsReport.vue?vue&type=template&id=1882ba11&"
import script from "./OnUsReport.vue?vue&type=script&lang=js&"
export * from "./OnUsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports